import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  SHARE,
  LIKE,
  COMMENT
} from '../../constants/ModalTypes';
import Post from '../../models/post';
import numberFormat from '../../utils/numberFormat';

export default class PostActionBar extends Component {
  static propTypes = {
    post: PropTypes.instanceOf(Post),
    showModal: PropTypes.func
  };

  constructor() {
    super();
    this.delta = 1;
  }

  shouldComponentUpdate(nextProps, nextState) {
    const isValueChanged = nextProps.post !== this.props.post;
    this.delta = (this.props.wheel - nextProps.wheel);
    const isToggleVisible = this.delta > 0;
    return isValueChanged || isToggleVisible;
  }

  get visible() {
    if (typeof window === 'undefined') {
      return 'on';
    }
    const { wheel } = this.props;
    const body = document.body;
    const html = document.documentElement;
    const height = Math.max(body.scrollHeight, body.offsetHeight, 
      html.clientHeight, html.scrollHeight, html.offsetHeight);
    if ((this.delta > 0 || wheel <= 0) && (wheel + window.innerHeight < height)) {
      return 'on';
    }
    return 'off';
  }

  render() {
    const { post, showModal, device } = this.props;
    const { likeCount, commentCount, shareCount, permalink } = post;
    return (
      <div className={`post_state ${this.visible}`}>{/* 상태바 사라질 때 클래스 off부여 / 다시 등장할 때 클래스 on부여 */}
        <strong className="screen_out">좋아요, 댓글, 공유 상태바</strong>
        <button type="button" className="btn_count" onClick={() => showModal(LIKE, { post, device })}>
          <span className="ico_plus ico_heart">좋아요</span>
          {(!post.blindType || post.blindType === '') ? (post.likeCount > 0 ? numberFormat(likeCount) : '좋아요') : 0}
        </button>
        <button type="button" className={`btn_count btn_cmt ${post.commentable ? '' : 'off'}`} onClick={() => post.commentable && showModal(COMMENT, { post, device })}>
          <span className="ico_plus ico_cmt">댓글</span>
          {(!post.blindType || post.blindType === '') ? (post.commentCount > 0 ? numberFormat(commentCount) : '댓글') : 0}
        </button>
        <button type="button" className={`btn_count ${!post.unlisted ? '' : 'off'}`}
          onClick={() => (!post.blindType || post.blindType === '') ? (!post.unlisted && showModal(SHARE, { post, permalink, device }))
          : alert('운영정책에 의해 제한된 게시물입니다.')}
        >
          <span className="ico_plus ico_share">공유</span>
          {(!post.blindType || post.blindType === '') ? (post.shareCount > 0 ? numberFormat(shareCount) : '공유') : 0}
        </button>
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./src/components/PostBox/PostActionBar.js